import { render, staticRenderFns } from "./Census.vue?vue&type=template&id=2f862ba6&"
import script from "./Census.vue?vue&type=script&lang=js&"
export * from "./Census.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports